import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Button,
  title: 'Button',
  category: ComponentCategory.General,
};
